<template>
    <div class="card mt-4">
        <div class="card-body">
            <FullCalendar :options="calendarOptions"/>
        </div>
    </div>
</template>

<script>
import Fullcalendar from "@fullcalendar/vue";
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from '@fullcalendar/list';
import frLocale from '@fullcalendar/core/locales/fr';
import axios from "axios";

export default {
    components: {
        Fullcalendar
    },
    data() {
        return {
            calendarOptions: {
                plugins: [listPlugin, dayGridPlugin, interactionPlugin],
                initialView: 'dayGridMonth',
                headerToolbar: {
                    left: 'title',
                    center: 'prev,next today',
                    right: 'dayGridMonth,listMonth'
                },
                dateClick: this.handleDateClick,
                locales: [frLocale],
                locale: 'fr',
                events: [

                ],
                eventColor: 'yellow',
                eventBackgroundColor: '#fff',
                eventClick: function(view) {
                    window.location = 'reunions/' + view.event.id
                }
            },
        }
    },

    mounted() {
        this.getEvents();
    },

    methods: {
        getEvents() {
            let newEvent = this.calendarOptions.events;
            axios
                .get("/api/events")
                .then(function (resp) {
                    for(let i = 0 ; i < resp.data.data.length ; i++) {
                        console.log(resp.data.data[i]);
                        newEvent.push(resp.data.data[i]);
                    }

                })
                .catch(function (err) {
                    console.log(err)
                });
        }
    }
};
</script>
